import React from 'react';

import {
  Grid,
  Button,
} from '@material-ui/core';
import NextIcon from '@material-ui/icons/ChevronRight';
import PrevIcon from '@material-ui/icons/ChevronLeft';
import DeleteIcon from '@material-ui/icons/DeleteOutline';

import InputField from '../../common/components/inputField';
import Alert from '../../common/components/Alert';

import * as constants from '../../config/constants';
import classes from '../../css/getCSS';
import pdfPreviewImage from '../../assets/img/pdf_preview.jpg';


const fileUploadForm = (props) => {
  let files = null;

  files = props.files.map((file) => {
    let url = null;
    if (file.file_type === 'IMAGE') {
      url = constants.BASE_URL + file.thumbnail;
    } else {
      url = pdfPreviewImage;
    }
    let avatarButton = null;
    if (props.editMode && !file.is_avatar && file.file_type === 'IMAGE') {
      avatarButton = (
        <Button
          variant="outlined"
          size="small"
          onClick={() => props.setAvatar(file.id)}
          style={{ marginRight: '5px' }}
        >
          Set as avatar
        </Button>
      );
    }
    let removeButton = (
      <Button
        variant="outlined"
        size="small"
        onClick={() => props.deleteFile(file.id)}
        className={classes.roundIconButton}
      >
        <DeleteIcon style={{ fontSize: '16px' }} />
      </Button>
    );
    if (props.editMode && props.fileType === 'IMAGE' && props.files.length === 1) {
      removeButton = null;
    }
    return (
      <Grid item md={3} xs={6} sm={3} align="center" key={file.id}>
        <img
          src={url}
          alt={file.file_type}
          className={classes.formImage}
        />
        <br />
        {avatarButton}
        {removeButton}
      </Grid>
    );
  });

  let uploadForm = null;
  if ((props.files.length < 1) || (props.files.length < 3 && props.fileType === 'IMAGE')) {
    uploadForm = (
      <Grid container spacing={8}>
        <Grid item md={6} xs={12} sm={6}>
          <InputField
            id="file"
            config={props.inputs.file}
            changed={event => props.inputChangedHandler(event, 'file')}
          />
        </Grid>
        <Grid item md={6} xs={12} sm={6} className={classes.uploadButton}>
          <Button variant="contained" type="submit" color="primary" className={classes.Button}>
            Upload
          </Button>
        </Grid>
      </Grid>
    );
  }

  let nonFieldErrors = null;
  if (props.errors) {
    nonFieldErrors = props.errors.map((error) => {
      return (
        <Alert key={error} type="danger">{error}</Alert>
      );
    });
  }

  let buttons = null;

  if (!props.editMode) {
    let nextButton = (
      <Button onClick={() => props.redirectToStep(props.nextStep)} variant="contained" color="primary" size="large" className={classes.Button}>
        Next
        <NextIcon />
      </Button>
    );
    if (props.fileType === 'IMAGE' && props.files.length === 0) {
      nextButton = null;
    }
    buttons = (
      <React.Fragment>
        <br />
        <hr className={classes.formHR} />
        <br />
        <Button onClick={() => props.redirectToStep(props.prevStep)} variant="contained" color="primary" size="large" className={classes.Button} style={{ marginRight: '10px' }}>
          <PrevIcon />
          Back
        </Button>
        {nextButton}
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      {props.editMode
        ? (
          <blockquote className={classes.profileFormQuote}>
            {props.fileType === 'IMAGE' ? 'You can upload max 3 photos' : 'Only PDF files allowed. You can upload max 1 file'}
          </blockquote>
        ) : null}
      {!props.editMode
        ? (
          <blockquote className={classes.profileFormQuote}>
            {props.fileType === 'IMAGE' ? 'Please upload your photo to proceed. Profiles without photos will not be approved.' : 'Only PDF files allowed. You can upload max 1 file'}
          </blockquote>
        ) : null}
      <br />
      {nonFieldErrors}
      <Grid container spacing={24}>
        {files}
      </Grid>
      <br /><br />
      {uploadForm}
      {buttons}
    </React.Fragment>
  );
};

export default fileUploadForm;



// WEBPACK FOOTER //
// ./src/profile/components/FileUploadForm.js